import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "h-30 overflow-hidden" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "flex flex-col items-start justify-start pl-4 h-full video__metadata" }
const _hoisted_4 = { class: "text-3xl font-semibold pb-4" }
const _hoisted_5 = ["innerHTML"]

import { Videos } from '@/generated/graphql';
import { computed } from 'vue';
import { useRouter } from 'vue-router';


type Props = {
    video: Videos;
    language: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'VideoPreview',
  props: {
    video: null,
    language: null
  },
  setup(__props: any) {

const props = __props as {
    video: Videos;
    language: string;
}


const router = useRouter();

const thumbnailURL = computed(() => {
    return `${process.env.VUE_APP_DIRECTUS}assets/${props.video.thumbnail?.id}`;
});

function openVideo() {
    if (props.video.video?.id === undefined) {
        return;
    }
    router.push({name: "video-display", params: {videoId: props.video.video.id, language: props.language}});
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "video__preview mb-3 flex justify-start items-start cursor-pointer",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (openVideo()))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        src: _unref(thumbnailURL),
        class: "video__thumbnail w-60"
      }, null, 8, _hoisted_2)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("span", _hoisted_4, _toDisplayString(__props.video.title), 1),
      _createElementVNode("div", {
        innerHTML: __props.video.description,
        class: "text-xl"
      }, null, 8, _hoisted_5)
    ])
  ]))
}
}

})